import { ref, watch } from 'vue'

// Дебаунс ввода в поле поиска ПВЗ + фильтр по типам сервисов.
// Дёргает родительский emit двумя событиями (filterPickpointsByField и
// filterPickpointsByType) — это исторический контракт CheckoutUnAuth.vue,
// который слушает оба и роутит в один handler.
//
// Аргументы:
//   emit — функция эмита родительского компонента
//
// Возвращает:
//   field_filterPickpoints — v-model для input
//   filterPickpoints       — handler для ListCheckbox (@callbackCheckboxes)
export default function usePickpointSearch({ emit }) {
  const field_filterPickpoints = ref('')
  const lastFilterValue = ref('')
  const types_v = ref([])

  function filterPickpoints(value) {
    types_v.value = value
  }

  function emitPickpointFilter(payload) {
    emit('filterPickpointsByField', payload)
    emit('filterPickpointsByType', payload)
  }

  watch(field_filterPickpoints, (nv) => {
    lastFilterValue.value = nv
    setTimeout(() => {
      if (nv === lastFilterValue.value) {
        emitPickpointFilter({ field: nv, types: types_v.value })
      }
    }, 400)
  })

  watch(
    types_v,
    () => {
      emitPickpointFilter({
        field: field_filterPickpoints.value,
        types: types_v.value,
      })
    },
    { deep: true }
  )

  return {
    field_filterPickpoints,
    filterPickpoints,
  }
}
